import { IconPlayWrapper } from '@anm/components/IconPlay';
import TitleBlock, { TitleDescription } from '@anm/components/TitleBlock';
import getFromCdn from '@anm/helpers/getFromCdn';
import { flexCenter, media } from '@anm/styles/helpers';
import slick from '@anm/styles/third-party/slick';
import styled, { css } from 'styled-components';

import { SliderArrowVariants } from '.';

const titleOnMobile = media.phone`
  font-size: 24px;
  max-width: 230px;
  line-height: 36px;
  margin: 0 auto 25px;
`;

export const Title = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4 {
    padding: 0 20px;
    font-size: 32px;
    font-weight: bold;
    line-height: 54px;
    text-align: center;
    margin-bottom: 37px;
    ${titleOnMobile};
  }
`;

const sliderOnMobile = media.phone`
.slick-slide {
  padding: 0;
  img {
    width: 100%;
  }
}
`;

export const SliderWrapper = styled.div`
  text-align: center;
  position: relative;

  ${slick}

  div {
    outline: none;
  }

  .slick-slider {
    margin: 0;
    width: 100%;
    position: static;
    min-height: 200px;
  }

  .slick-slide {
    img {
      max-width: 100%;
    }
    padding: 0 ${35 / 2}px;
  }
  .slick-dots {
    bottom: -10px;
    li button::before {
      font-size: 15px;
    }
  }
  ${sliderOnMobile};
`;

const variants: { [key in SliderArrowVariants]: ReturnType<typeof css> } = {
  left: css`
    top: -75px;
    right: 67px;
  `,
  right: css`
    top: -75px;
    right: 21px;
    transform: rotate(180deg);
  `
};

const arrowOnMobile = media.phone`
  display: none!important;
`;

export const SliderArrowWrapper = styled.button<{
  direction: SliderArrowVariants;
}>`
  top: 25%;
  z-index: 1;
  border: none;
  width: 24px;
  height: 24px;
  cursor: pointer;
  position: absolute;
  background: url('${getFromCdn('images/arrow_left_slider.svg')}') no-repeat
      center / contain;
  ${({ direction }) => variants[direction]};
  ${arrowOnMobile};
  &:focus {
    outline: none;
  }
`;

export const SectionWrapper = styled.section`
  margin: 0 auto;
  max-width: 1185px;
  margin-top: 100px;
  position: relative;
`;

export const SliderCounter = styled.p`
  top: 12px;
  margin: 0;
  right: 126px;
  color: #919eaa;
  font-size: 20px;
  line-height: 32px;
  font-weight: bold;
  position: absolute;
  letter-spacing: 0.5px;
  &:first-letter {
    color: #000;
  }
`;

export const SlideWrapper = styled.div`
  position: relative;
  ${IconPlayWrapper} {
    cursor: pointer;
  }
`;

const customerDetailsOnMobile = media.phone`
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 16px;
    margin-bottom: 0;
    line-height: 25px;
  }
  ${TitleDescription} {
    margin: 0;
    font-size: 12px;
    line-height: 20px;
  }
`;

export const CustomerDetails = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 24px;
    text-align: left;
    line-height: 36px;
    font-weight: bold;
    margin-bottom: 2px;
  }
  ${TitleDescription} {
    opacity: 0.5;
    color: #292a2b;
    font-size: 16px;
    text-align: left;
    line-height: 25px;
    font-weight: normal;
    margin-bottom: 14px;
  }
  ${customerDetailsOnMobile};
`;

const mediaWrapperOnMobile = media.phone`
  margin-left: 10px;
`;

export const SocialMediaWrapper = styled.div`
  display: flex;
  flex-direction: row;
  img {
    outline: none;
    margin-right: 6.8px;
    max-width: 22.5px !important;
  }
  a:focus {
    outline: none;
  }
  ${mediaWrapperOnMobile};
`;

const loaderContainerOnMobile = media.phone`
  width: 100vw;
`;

export const LoaderContainer = styled.div`
  ${flexCenter};
  width: 100%;
  height: 100%;
  min-height: 300px;
  ${loaderContainerOnMobile}
`;

export const ImageContainer = styled.div`
  position: relative;
`;

const infoWrapperOnMobile = media.phone`
  display: flex;
  flex-direction: row;
  padding: 21px 20px 23px;
`;

export const InfoWrapper = styled.div`
  padding-top: 19px;
  ${infoWrapperOnMobile};
`;

export const PlayerContainer = styled.div<{ width?: number }>`
  margin: auto;
  position: relative;
  pointer-events: all;
  min-width: ${({ width }) => width || 1}px;
  opacity: ${({ width }) => (width ? 1 : 0)};
`;

export const CloseButton = styled.span`
  &:after {
    top: 10px;
    right: 20px;
    content: '✕';
    color: #919eaa;
    font-size: 40px;
    position: absolute;
    cursor: pointer;
  }
`;
